import { useEffect } from "react";

function useDeprecated(deprecatedComponent, newComponent) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn(
      `Warning: ${deprecatedComponent} is deprecated and will be removed in the next major version. Use ${newComponent} instead`
    );
  }, [deprecatedComponent, newComponent]);
}

export default useDeprecated;
